import React from "react";
import "./style.scss";
export default function SearchBar(props) {
  return (
    <div className="input-search-bar">
      <input
        {...props}
        type="text"
        className="appearance-none outline-none w-full"
      />
      <span className="pi pi-search"></span>
    </div>
  );
}
